import React, { useEffect, useState } from "react";
import { Box, Button, Grid, TextField, Typography, CircularProgress, Avatar as AvatarMui, FormGroup, FormControlLabel, Checkbox } from "@material-ui/core";
import SearchIcon from '@material-ui/icons/Search';
import useStyles from './styles';
import { handleUndefined, postDataRequest } from "../../common/commonfunctions";
import { showNotification } from "../../components/Notification/ToastifyNotifications";
import config from "../../config";
import { useGlobalState } from '../../context/GlobalContext';
import { findEmailByDomain } from "../../Api Mutation/Campaign";
import { CreateContact, CRMcontactByData, UpdateContact } from "../../Api Mutation/Contact";
import { LoadingPage } from "../LoadingPage/LoadingPage";

export default function EmailFinder({
    contactId,
    handleClose
}) {
    const classes = useStyles();
    const globalContext = useGlobalState();
    const [loading, setLoading] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [domain, setDomain] = useState(null);
    const [linkedinUrl, setLinkedinUrl] = useState(null);
    const [email, setEmail] = useState(null);
    const [contactLoading, setContactLoading] = useState(false);
    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState('');
    const [isLinkeIn, setIsLinkedIn] = useState(false);

    useEffect(() => {
        if (contactId) {
            setContactLoading(true);
            postDataRequest(config.baseURLApi, {
                query: CRMcontactByData,
                variables: {
                    contactid: contactId,
                },
            }).then(res => {
                const result = res?.data?.contact;
                if (res?.errors && res?.errors[0]?.message) {
                    showNotification(res.errors[0].message, 'error');
                } else if (result) {
                    setFirstName(result?.firstname);
                    setLastName(result?.lastname);
                    setLinkedinUrl(result?.linkedin);
                }
                setContactLoading(false);
            });
        }
    }, [contactId])
    return (
        <>
            {contactLoading ? <LoadingPage /> : ''}
            <Box style={{ marginTop: 30 }}>
                <center>
                    <Typography variant="h4">Email Finder</Typography>
                    <Typography variant="h2" style={{ color: '#005eb2', fontWeight: 500 }}>Find the verified email address</Typography>
                    <Typography variant="h2" style={{ fontWeight: 500 }}>of any professional.</Typography>
                </center>
            </Box>
            <Box className={contactId ? classes.newBox : classes.Box}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            size="small"
                            type="text"
                            label="First Name *"
                            placeholder="Enter a FirstName *"
                            variant="outlined"
                            InputProps={{
                                style: { height: 38 },
                            }}
                            InputLabelProps={{
                                style: { marginTop: 1 },
                            }}
                            value={firstName || ''}
                            onChange={(e) => {
                                setFirstName(e.target.value);
                                setEmail(null);
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="text"
                            label="Last Name *"
                            placeholder="Enter a LastName *"
                            variant="outlined"
                            size="small"
                            InputProps={{
                                style: { height: 38 },
                            }}
                            InputLabelProps={{
                                style: { marginTop: 1 },
                            }}
                            value={lastName || ''}
                            onChange={(e) => {
                                setLastName(e.target.value);
                                setEmail(null);
                            }}
                        />
                    </Grid>
                    {!isLinkeIn && (
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                type="text"
                                label="Enter Company Domain"
                                placeholder="Enter Company Domain"
                                variant="outlined"
                                size="small"
                                InputProps={{
                                    style: { height: 38 },
                                }}
                                InputLabelProps={{
                                    style: { marginTop: 1 },
                                }}
                                value={domain}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setDomain(value);
                                    const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/;
                                    if (value && !domainRegex.test(value)) {
                                        setError(true);
                                        setHelperText("Please enter a valid domain (e.g. example.com)");
                                    } else {
                                        setError(false);
                                        setHelperText("");
                                    }
                                }}
                                error={error}
                                helperText={helperText}
                            />
                        </Grid>
                    )}
                    <Grid item xs={12} md={6}>
                        <FormGroup>
                            <FormControlLabel
                                control={<Checkbox checked={isLinkeIn} onChange={(e) => setIsLinkedIn(e.target.checked)} />}
                                label="Find By LinkedIn Profile"
                                color='primary'
                            />
                        </FormGroup>
                    </Grid>
                    {isLinkeIn && (
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                type="text"
                                label="LinkedIn Profile"
                                placeholder="LinkedIn Profile"
                                variant="outlined"
                                size="small"
                                InputProps={{
                                    style: { height: 38 },
                                }}
                                InputLabelProps={{
                                    style: { marginTop: 1 },
                                }}
                                value={linkedinUrl || ''}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setLinkedinUrl(value);
                                }}
                            />
                        </Grid>
                    )}
                    <Grid item xs={12} md={12}>
                        <center>
                            <Button
                                startIcon={loading ? <CircularProgress color="inherit" size={18} /> : <SearchIcon />}
                                size="small"
                                variant="contained"
                                fullWidth
                                className={classes.emailButton}
                                disabled={loading}
                                onClick={() => {
                                    if (!firstName) {
                                        showNotification('First Name is required to find email', 'error');
                                    } else if (!lastName) {
                                        showNotification('Last Name is required to find email', 'error');
                                    } else if (!domain && !isLinkeIn) {
                                        showNotification('Please provide domain to find email', 'error');
                                    } else if (isLinkeIn && !linkedinUrl) {
                                        showNotification('Please provide LinkedIn Profile URL to find email', 'error');
                                    } else {
                                        const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/;
                                        if (domain && !domainRegex.test(domain) && !isLinkeIn) {
                                            showNotification('Please enter a valid domain (e.g. example.com) or LinkedIn Profile URL', 'error');
                                        } else {
                                            setLoading(true);
                                            postDataRequest(config.emailFinderApi, {
                                                query: findEmailByDomain,
                                                variables: {
                                                    firstname: firstName,
                                                    lastname: lastName,
                                                    domain: domain,
                                                    createdby: globalContext?.globalState?.userInfo?.userid,
                                                    locationid: globalContext.globalState.currentLocation.entityid,
                                                    businessid: globalContext?.globalState?.currentLocation?.parententityid,
                                                    linkedinurl: isLinkeIn ? linkedinUrl : null,
                                                },
                                            }).then((res) => {
                                                if (res?.errors && res?.errors[0]?.message) {
                                                    showNotification(res.errors[0].message, 'error');
                                                } else if (res?.data?.findEmailByDomain !== '') {
                                                    setEmail(res?.data?.findEmailByDomain);
                                                    showNotification(`${linkedinUrl && isLinkeIn ? 2 : 1} credit has been debited to find this email`, 'success');
                                                } else {
                                                    setEmail('Verified email not found for this contact');
                                                }
                                                setLoading(false);
                                            }).catch((err) => {
                                                setLoading(false);
                                                showNotification(err, 'error');
                                            });
                                        }
                                    }

                                }}
                            >
                                Find Email
                            </Button>
                        </center>
                    </Grid>
                </Grid>
            </Box>
            {email ? (
                <Box className={classes.mainBox}>
                    <Box className={classes.childBox}>
                        <AvatarMui className={classes.split} src={null}>
                            {handleUndefined(firstName?.charAt(0)) + handleUndefined(lastName?.charAt(0))}
                        </AvatarMui>
                        <Box style={{ marginLeft: 10 }}>
                            <Typography variant="body1" style={{ fontSize: 17 }}>{handleUndefined(firstName).charAt(0).toUpperCase() + handleUndefined(firstName).slice(1) + ' ' + handleUndefined(lastName).charAt(0).toUpperCase() + handleUndefined(lastName).slice(1)}</Typography>
                            <Typography variant="body1">{email}</Typography>
                        </Box>
                    </Box>
                    {email.includes('@') && (
                        <Box>
                            <Button
                                size="small"
                                variant="contained"
                                fullWidth
                                className={contactId ? classes.contactbtn : classes.btn}
                                disabled={contactLoading}
                                onClick={() => {
                                    setContactLoading(true);
                                    if (contactId) {
                                        postDataRequest(config.baseURLApi, {
                                            query: UpdateContact,
                                            variables: {
                                                contactid: contactId,
                                                primaryemail: email,
                                                ownerid: globalContext?.globalState?.userInfo?.userid,
                                                locationid: globalContext.globalState.currentLocation.entityid,
                                                updatedby: globalContext?.globalState?.userInfo?.userid,
                                            },
                                        }).then((res) => {
                                            if (res?.errors && res?.errors[0]?.message) {
                                                showNotification(res.errors[0].message, 'error');
                                            } else if (res?.data?.updateContact) {
                                                handleClose();
                                                setFirstName(null);
                                                setLastName(null);
                                                setDomain(null);
                                                setLinkedinUrl(null);
                                                setEmail(null);
                                                setIsLinkedIn(false);
                                                showNotification('Email saved in contact Successfully', 'success');
                                            }
                                            setContactLoading(false);
                                        }).catch((err) => {
                                            setContactLoading(false);
                                            showNotification(err, 'error');
                                        });
                                    } else {
                                        const contactObj = {
                                            firstname: firstName,
                                            lastname: lastName,
                                            primaryemail: email,
                                            lifecyclestage: '2',
                                            status: 3,
                                            ownerid: globalContext?.globalState?.userInfo?.userid,
                                            locationid: globalContext.globalState.currentLocation.entityid,
                                            createdby: globalContext?.globalState?.userInfo?.userid,
                                        };
                                        postDataRequest(config.baseURLApi, {
                                            query: CreateContact,
                                            variables: contactObj,
                                        }).then((res) => {
                                            if (res?.errors && res?.errors[0]?.message) {
                                                showNotification(res.errors[0].message, 'error');
                                            } else if (res?.data?.createContact) {
                                                setFirstName(null);
                                                setLastName(null);
                                                setDomain(null);
                                                setLinkedinUrl(null);
                                                setEmail(null);
                                                setIsLinkedIn(false);
                                                showNotification('Contact Created Successfully', 'success');
                                            }
                                            setContactLoading(false);
                                        }).catch((err) => {
                                            setContactLoading(false);
                                            showNotification(err, 'error');
                                        });
                                    }
                                }}
                            >
                                {contactId ? 'Add Email To Contact' : 'Add To Contact'}
                            </Button>
                        </Box>
                    )}
                </Box>
            ) : ''}
        </>
    );
};